import { render, staticRenderFns } from "./CloneCompanyFormModal.vue?vue&type=template&id=80af4cca&"
import script from "./CloneCompanyFormModal.vue?vue&type=script&lang=js&"
export * from "./CloneCompanyFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports